import type { ContactPageLocaleContent } from '../types'

export const contactPageEn: ContactPageLocaleContent = {
  title: 'Contact - Toolvance',
  description: 'Contact Toolvance.',
  metadata: {
    ogTitle: 'Contact - Toolvance',
    ogDescription: 'Contact Toolvance.',
    robots: 'noindex',
  },
  content: {
    heading: 'Contact',
    intro: 'Have a question, found a bug, or want to suggest a calculator?',
    emailPrefix: 'Email us at:',
  },
}
